import React from "react";
import { BDOperation, BDUpdateType } from "../../../../integrated-client";
import {getFormattedDateAndTimeFromString} from "../../../../utils/MiscUtils";
import styles from './HistoryLog.module.css';

interface IHistoryLogProps {
  actionHistoryData: BDOperation
}

enum historyActions {
  Added = 'created entity',
  Deleted = 'deleted entity',
  Updated = 'made changes'
}

const HistoryLog: React.FC<IHistoryLogProps> = (props) => {
  const { updatedBy, updatedDate, type, updates } = props.actionHistoryData
  let action = ""
  switch (type) {
    case BDUpdateType.Added: {
      action = historyActions.Added;
      break
    }
    case BDUpdateType.Deleted: {
      action = historyActions.Deleted;
      break
    }
    case BDUpdateType.Updated: {
      action = historyActions.Updated;
      break
    }
    default:
      break
  }

  function NewlineText(text: string) {
    return <div className={styles.historyUpdateItem}>
      {
        text?.split('\n')
          .map(str => <>{str}<br /></>)
      }
    </div>;
  }

  return (
    <>
      <div>
        <div>
          <span className={styles.actionLine}>
            <span className={styles.updatedBy}>{updatedBy} </span>
            {action} - {getFormattedDateAndTimeFromString(updatedDate)}
          </span>

          {updates?.length ?
            <div className={styles.historyUpdateItemsWrapper}>
              <div className={styles.historyUpdateItemCaptions}>
                <div className={styles.historyUpdateItemCaption}><strong>Field</strong></div>
                <div className={styles.historyUpdateItemCaption}><strong>Original Value</strong></div>
                <div className={styles.historyUpdateItemCaption}><strong>New Value</strong></div>
              </div>
              {updates.map((update) => {
                return <div className={styles.historyUpdateItems}>
                  <div className={styles.historyUpdateItem}>{update.name}</div>
                  {NewlineText(update.oldValue!)}
                  {NewlineText(update.newValue!)}
                </div>
              })
              }
            </div>
            : null
          }
        </div>
      </div>
    </>
  )
}

export default HistoryLog
